export const ExteriorSignageQuoteAttachedFileTypeEnum = {
  Logo: 1,
  OEM: 2,
};
